var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "check" }, [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.user.selected,
              expression: "user.selected"
            }
          ],
          staticClass: "checkbox01-input",
          attrs: { type: "checkbox", disabled: "" },
          domProps: {
            checked: Array.isArray(_vm.user.selected)
              ? _vm._i(_vm.user.selected, null) > -1
              : _vm.user.selected
          },
          on: {
            change: function($event) {
              var $$a = _vm.user.selected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.user, "selected", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.user,
                      "selected",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.user, "selected", $$c)
              }
            }
          }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "checkbox01-parts",
          on: { click: _vm.onUserByGroupChange }
        })
      ])
    ]),
    _vm._v(" "),
    _c("td", {
      staticClass: "user",
      domProps: { textContent: _vm._s(_vm.user.userName) },
      on: { click: _vm.onUserByGroupChange }
    }),
    _vm._v(" "),
    _c("td", {
      staticClass: "area",
      domProps: { textContent: _vm._s(_vm.user.orgName) },
      on: { click: _vm.onUserByGroupChange }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }